import { render, staticRenderFns } from "./DetailContentLibrary.vue?vue&type=template&id=9c978d12&scoped=true"
import script from "./DetailContentLibrary.vue?vue&type=script&lang=js"
export * from "./DetailContentLibrary.vue?vue&type=script&lang=js"
import style0 from "./DetailContentLibrary.vue?vue&type=style&index=0&id=9c978d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c978d12",
  null
  
)

export default component.exports